const TIER_BADGE_CLASS_NAMES: Record<string, string> = {
  "Tier 1": "bg-green-100 text-green-800",
  "Tier 2": "bg-emerald-100 text-emerald-800",
  "Tier 3": "bg-yellow-100 text-yellow-800",
  "Tier 4": "bg-orange-100 text-orange-800",
  "Tier 5": "bg-red-100 text-red-800",
  "Tier Prova": "bg-blue-100 text-blue-800",
};

export function tierLabel(
  tierRank: number | null,
  inTrial: boolean,
): string | null {
  if (inTrial) return "Tier Prova";
  return tierRank ? `Tier ${tierRank}` : null;
}

export function tierBadgeClassName(tier: string | null): string {
  return (
    (tier ? TIER_BADGE_CLASS_NAMES[tier] : undefined) ??
    "bg-slate-100 text-slate-700"
  );
}
